// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__4McWl","title":"AfterBackImages_title__YcC_P","images":"AfterBackImages_images__3Yttr"};